import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  [
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-transparent',
    'text-sm font-semibold tracking-[-0.01em]',
    'transition-colors transition-shadow duration-200 ease-out',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
    'disabled:pointer-events-none disabled:opacity-50',
    '[&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  ].join(' '),
  {
    variants: {
      variant: {
        default:
          'border-[hsl(var(--primary)/0.35)] bg-[hsl(var(--primary)/0.92)] text-primary-foreground shadow-[inset_0_1px_0_hsl(40_30%_96%/0.2)] backdrop-blur-[10px] hover:bg-[hsl(var(--primary)/0.86)] active:bg-[hsl(var(--primary)/0.9)]',
        destructive:
          'border-[hsl(var(--destructive)/0.35)] bg-[hsl(var(--destructive)/0.92)] text-destructive-foreground shadow-[inset_0_1px_0_hsl(40_30%_96%/0.15)] backdrop-blur-[10px] hover:bg-[hsl(var(--destructive)/0.86)] active:bg-[hsl(var(--destructive)/0.9)]',
        outline:
          'border-[var(--glass-border-color)] bg-[var(--glass-bg-control)] text-foreground shadow-[var(--glass-shadow-inset)] backdrop-blur-[10px] hover:border-[hsl(40_16%_74%/0.85)] hover:bg-[var(--glass-bg-strong)] active:bg-[var(--glass-bg)]',
        secondary:
          'border-[var(--glass-border-subtle)] bg-[var(--glass-bg-subtle)] text-secondary-foreground shadow-[var(--glass-shadow-inset)] backdrop-blur-[10px] hover:bg-[var(--glass-bg)] active:bg-[var(--glass-bg-subtle)]',
        ghost:
          'border-transparent bg-transparent text-foreground hover:border-[var(--glass-border-subtle)] hover:bg-[var(--glass-bg-subtle)] hover:shadow-[var(--glass-shadow-inset)] active:bg-[var(--glass-bg-subtle)]',
        link: 'border-transparent bg-transparent text-primary underline-offset-4 hover:underline',
      },
      size: {
        default:
          'h-12 min-h-[var(--button-height)] min-w-[var(--button-min-width)] shrink-0 px-5 py-2.5',
        sm: 'h-11 min-h-[var(--button-height-sm)] min-w-[var(--button-min-width)] shrink-0 rounded-lg px-5 text-sm font-medium [&_svg]:size-4',
        lg: 'h-14 min-h-[var(--button-height-lg)] min-w-[var(--button-min-width)] shrink-0 rounded-lg px-8 text-base [&_svg]:size-5',
        icon: 'size-12 shrink-0 p-0 [&_svg]:size-5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);
